"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstrumentRepository = void 0;
class InstrumentRepository {
    constructor() {
        this._lookup = new Map();
        // This should really be done dynamically on initialisation by the front end. However, due to certain exchanges having
        // a CORS policy on their instruments endpoint, a proxy would be required, and I felt this would have added more
        // complexity to a simple demo. 
        this._lookup.set('FTX', [
            { 'symbol': '1INCH-PERP', 'tickSize': 0.0001 },
            { 'symbol': 'AAVE-PERP', 'tickSize': 0.01 },
            { 'symbol': 'ADA-PERP', 'tickSize': 5e-06 },
            { 'symbol': 'AGLD-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'ALCX-PERP', 'tickSize': 0.1 },
            { 'symbol': 'ALGO-PERP', 'tickSize': 0.0001 },
            { 'symbol': 'ALICE-PERP', 'tickSize': 0.0025 },
            { 'symbol': 'ALPHA-PERP', 'tickSize': 5e-05 },
            { 'symbol': 'ALT-PERP', 'tickSize': 0.05 },
            { 'symbol': 'AMPL-PERP', 'tickSize': 0.0001 },
            { 'symbol': 'ANC-PERP', 'tickSize': 0.00025 },
            { 'symbol': 'APE-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'AR-PERP', 'tickSize': 0.001 },
            { 'symbol': 'ASD-PERP', 'tickSize': 1e-05 },
            { 'symbol': 'ATLAS-PERP', 'tickSize': 2.5e-07 },
            { 'symbol': 'ATOM-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'AUDIO-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'AVAX-PERP', 'tickSize': 0.001 },
            { 'symbol': 'AXS-PERP', 'tickSize': 0.001 },
            { 'symbol': 'BADGER-PERP', 'tickSize': 0.005 },
            { 'symbol': 'BAL-PERP', 'tickSize': 0.0025 },
            { 'symbol': 'BAND-PERP', 'tickSize': 0.001 },
            { 'symbol': 'BAO-PERP', 'tickSize': 2.5e-07 },
            { 'symbol': 'BAT-PERP', 'tickSize': 2.5e-05 },
            { 'symbol': 'BCH-PERP', 'tickSize': 0.05 },
            { 'symbol': 'BIT-PERP', 'tickSize': 0.00025 },
            { 'symbol': 'BNB-PERP', 'tickSize': 0.0025 },
            { 'symbol': 'BNT-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'BOBA-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'BRZ-PERP', 'tickSize': 1e-05 },
            { 'symbol': 'BSV-PERP', 'tickSize': 0.01 },
            { 'symbol': 'BTC-PERP', 'tickSize': 1.0 },
            { 'symbol': 'BTT-PERP', 'tickSize': 1e-08 },
            { 'symbol': 'C98-PERP', 'tickSize': 0.0001 },
            { 'symbol': 'CAKE-PERP', 'tickSize': 0.0025 },
            { 'symbol': 'CEL-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'CELO-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'CHR-PERP', 'tickSize': 5e-05 },
            { 'symbol': 'CHZ-PERP', 'tickSize': 1e-06 },
            { 'symbol': 'CLV-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'COMP-PERP', 'tickSize': 0.01 },
            { 'symbol': 'CONV-PERP', 'tickSize': 1e-05 },
            { 'symbol': 'CREAM-PERP', 'tickSize': 0.05 },
            { 'symbol': 'CRO-PERP', 'tickSize': 2.5e-05 },
            { 'symbol': 'CRV-PERP', 'tickSize': 5e-05 },
            { 'symbol': 'CUSDT-PERP', 'tickSize': 2.5e-06 },
            { 'symbol': 'CVC-PERP', 'tickSize': 5e-05 },
            { 'symbol': 'CVX-PERP', 'tickSize': 0.0025 },
            { 'symbol': 'DASH-PERP', 'tickSize': 0.025 },
            { 'symbol': 'DAWN-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'DEFI-PERP', 'tickSize': 0.1 },
            { 'symbol': 'DENT-PERP', 'tickSize': 1e-06 },
            { 'symbol': 'DODO-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'DOGE-PERP', 'tickSize': 5e-07 },
            { 'symbol': 'DOT-PERP', 'tickSize': 0.001 },
            { 'symbol': 'DRGN-PERP', 'tickSize': 0.1 },
            { 'symbol': 'DYDX-PERP', 'tickSize': 0.001 },
            { 'symbol': 'EDEN-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'EGLD-PERP', 'tickSize': 0.005 },
            { 'symbol': 'ENJ-PERP', 'tickSize': 5e-05 },
            { 'symbol': 'ENS-PERP', 'tickSize': 0.005 },
            { 'symbol': 'EOS-PERP', 'tickSize': 0.00025 },
            { 'symbol': 'ETC-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'ETH-PERP', 'tickSize': 0.1 },
            { 'symbol': 'EXCH-PERP', 'tickSize': 0.1 },
            { 'symbol': 'FIDA-PERP', 'tickSize': 0.0001 },
            { 'symbol': 'FIL-PERP', 'tickSize': 0.005 },
            { 'symbol': 'FLM-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'FLOW-PERP', 'tickSize': 0.005 },
            { 'symbol': 'FTM-PERP', 'tickSize': 5e-05 },
            { 'symbol': 'FTT-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'FXS-PERP', 'tickSize': 0.0025 },
            { 'symbol': 'GALA-PERP', 'tickSize': 2.5e-05 },
            { 'symbol': 'GLMR-PERP', 'tickSize': 0.00025 },
            { 'symbol': 'GMT-PERP', 'tickSize': 5e-05 },
            { 'symbol': 'GRT-PERP', 'tickSize': 5e-05 },
            { 'symbol': 'HBAR-PERP', 'tickSize': 5e-05 },
            { 'symbol': 'HNT-PERP', 'tickSize': 0.0001 },
            { 'symbol': 'HOLY-PERP', 'tickSize': 0.0001 },
            { 'symbol': 'HOT-PERP', 'tickSize': 1e-06 },
            { 'symbol': 'HT-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'HUM-PERP', 'tickSize': 2.5e-05 },
            { 'symbol': 'ICP-PERP', 'tickSize': 0.01 },
            { 'symbol': 'ICX-PERP', 'tickSize': 5e-05 },
            { 'symbol': 'IMX-PERP', 'tickSize': 0.00025 },
            { 'symbol': 'IOST-PERP', 'tickSize': 5e-06 },
            { 'symbol': 'IOTA-PERP', 'tickSize': 0.0001 },
            { 'symbol': 'JASMY-PERP', 'tickSize': 2.5e-06 },
            { 'symbol': 'KAVA-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'KBTT-PERP', 'tickSize': 2.5e-07 },
            { 'symbol': 'KIN-PERP', 'tickSize': 1e-08 },
            { 'symbol': 'KNC-PERP', 'tickSize': 0.0001 },
            { 'symbol': 'KSHIB-PERP', 'tickSize': 1e-05 },
            { 'symbol': 'KSM-PERP', 'tickSize': 0.01 },
            { 'symbol': 'KSOS-PERP', 'tickSize': 5e-07 },
            { 'symbol': 'LEO-PERP', 'tickSize': 0.0001 },
            { 'symbol': 'LINA-PERP', 'tickSize': 5e-06 },
            { 'symbol': 'LINK-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'LOOKS-PERP', 'tickSize': 0.00025 },
            { 'symbol': 'LRC-PERP', 'tickSize': 5e-05 },
            { 'symbol': 'LTC-PERP', 'tickSize': 0.01 },
            { 'symbol': 'LUNA-PERP', 'tickSize': 0.001 },
            { 'symbol': 'MANA-PERP', 'tickSize': 0.0001 },
            { 'symbol': 'MAPS-PERP', 'tickSize': 0.0001 },
            { 'symbol': 'MATIC-PERP', 'tickSize': 2.5e-06 },
            { 'symbol': 'MCB-PERP', 'tickSize': 0.005 },
            { 'symbol': 'MEDIA-PERP', 'tickSize': 0.1 },
            { 'symbol': 'MER-PERP', 'tickSize': 0.0001 },
            { 'symbol': 'MID-PERP', 'tickSize': 0.1 },
            { 'symbol': 'MINA-PERP', 'tickSize': 0.00025 },
            { 'symbol': 'MKR-PERP', 'tickSize': 0.5 },
            { 'symbol': 'MNGO-PERP', 'tickSize': 2.5e-05 },
            { 'symbol': 'MOB-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'MTA-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'MTL-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'MVDA10-PERP', 'tickSize': 2.5 },
            { 'symbol': 'MVDA25-PERP', 'tickSize': 2.5 },
            { 'symbol': 'NEAR-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'NEO-PERP', 'tickSize': 0.0025 },
            { 'symbol': 'OKB-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'OMG-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'ONE-PERP', 'tickSize': 2.5e-05 },
            { 'symbol': 'ONT-PERP', 'tickSize': 5e-05 },
            { 'symbol': 'ORBS-PERP', 'tickSize': 2.5e-05 },
            { 'symbol': 'OXY-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'PAXG-PERP', 'tickSize': 0.1 },
            { 'symbol': 'PEOPLE-PERP', 'tickSize': 1e-05 },
            { 'symbol': 'PERP-PERP', 'tickSize': 0.001 },
            { 'symbol': 'POLIS-PERP', 'tickSize': 2.5e-05 },
            { 'symbol': 'PRIV-PERP', 'tickSize': 0.1 },
            { 'symbol': 'PROM-PERP', 'tickSize': 0.005 },
            { 'symbol': 'PUNDIX-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'QTUM-PERP', 'tickSize': 0.001 },
            { 'symbol': 'RAMP-PERP', 'tickSize': 0.0001 },
            { 'symbol': 'RAY-PERP', 'tickSize': 0.0001 },
            { 'symbol': 'REEF-PERP', 'tickSize': 5e-06 },
            { 'symbol': 'REN-PERP', 'tickSize': 5e-05 },
            { 'symbol': 'RNDR-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'RON-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'ROOK-PERP', 'tickSize': 0.05 },
            { 'symbol': 'ROSE-PERP', 'tickSize': 5e-05 },
            { 'symbol': 'RSR-PERP', 'tickSize': 5e-06 },
            { 'symbol': 'RUNE-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'SAND-PERP', 'tickSize': 5e-05 },
            { 'symbol': 'SC-PERP', 'tickSize': 2.5e-06 },
            { 'symbol': 'SCRT-PERP', 'tickSize': 5e-05 },
            { 'symbol': 'SECO-PERP', 'tickSize': 0.0001 },
            { 'symbol': 'SHIB-PERP', 'tickSize': 1e-08 },
            { 'symbol': 'SHIT-PERP', 'tickSize': 0.1 },
            { 'symbol': 'SKL-PERP', 'tickSize': 0.0001 },
            { 'symbol': 'SLP-PERP', 'tickSize': 2.5e-05 },
            { 'symbol': 'SNX-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'SOL-PERP', 'tickSize': 0.0025 },
            { 'symbol': 'SOS-PERP', 'tickSize': 1e-08 },
            { 'symbol': 'SPELL-PERP', 'tickSize': 2.5e-06 },
            { 'symbol': 'SRM-PERP', 'tickSize': 0.001 },
            { 'symbol': 'SRN-PERP', 'tickSize': 5e-06 },
            { 'symbol': 'STEP-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'STMX-PERP', 'tickSize': 5e-06 },
            { 'symbol': 'STORJ-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'STX-PERP', 'tickSize': 0.00025 },
            { 'symbol': 'SUSHI-PERP', 'tickSize': 0.0001 },
            { 'symbol': 'SXP-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'THETA-PERP', 'tickSize': 5e-05 },
            { 'symbol': 'TLM-PERP', 'tickSize': 5e-05 },
            { 'symbol': 'TOMO-PERP', 'tickSize': 5e-05 },
            { 'symbol': 'TONCOIN-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'TRU-PERP', 'tickSize': 2.5e-05 },
            { 'symbol': 'TRX-PERP', 'tickSize': 2.5e-06 },
            { 'symbol': 'TRYB-PERP', 'tickSize': 1e-05 },
            { 'symbol': 'TULIP-PERP', 'tickSize': 0.0025 },
            { 'symbol': 'UNI-PERP', 'tickSize': 0.001 },
            { 'symbol': 'UNISWAP-PERP', 'tickSize': 25.0 },
            { 'symbol': 'USDT-PERP', 'tickSize': 0.0001 },
            { 'symbol': 'UST-PERP', 'tickSize': 0.0001 },
            { 'symbol': 'VET-PERP', 'tickSize': 5e-06 },
            { 'symbol': 'WAVES-PERP', 'tickSize': 0.0005 },
            { 'symbol': 'XAUT-PERP', 'tickSize': 0.1 },
            { 'symbol': 'XEM-PERP', 'tickSize': 5e-05 },
            { 'symbol': 'XLM-PERP', 'tickSize': 2.5e-05 },
            { 'symbol': 'XMR-PERP', 'tickSize': 0.01 },
            { 'symbol': 'XRP-PERP', 'tickSize': 2.5e-05 },
            { 'symbol': 'XTZ-PERP', 'tickSize': 0.0001 },
            { 'symbol': 'YFI-PERP', 'tickSize': 5.0 },
            { 'symbol': 'YFII-PERP', 'tickSize': 0.25 },
            { 'symbol': 'ZEC-PERP', 'tickSize': 0.01 },
            { 'symbol': 'ZIL-PERP', 'tickSize': 1e-05 },
            { 'symbol': 'ZRX-PERP', 'tickSize': 0.00025 }
        ]);
        this._lookup.set('Mango', [
            { 'symbol': 'MNGO-PERP', 'tickSize': 0.0001 },
            { 'symbol': 'BTC-PERP', 'tickSize': 0.1 },
            { 'symbol': 'ETH-PERP', 'tickSize': 0.1 },
            { 'symbol': 'SOL-PERP', 'tickSize': 0.01 },
            { 'symbol': 'SRM-PERP', 'tickSize': 0.001 },
            { 'symbol': 'RAY-PERP', 'tickSize': 0.001 },
            { 'symbol': 'FTT-PERP', 'tickSize': 0.001 },
            { 'symbol': 'ADA-PERP', 'tickSize': 0.0001 },
            { 'symbol': 'BNB-PERP', 'tickSize': 0.1 },
            { 'symbol': 'AVAX-PERP', 'tickSize': 0.01 },
            { 'symbol': 'LUNA-PERP', 'tickSize': 0.01 }
        ]);
        this._lookup.set('BitMEX', [
            { 'symbol': 'XBTUSD', 'tickSize': 0.5, 'symbolIndex': 88 },
            { 'symbol': 'ETHUSD', 'tickSize': 0.05, 'symbolIndex': 297 },
            { 'symbol': 'XRPUSD', 'tickSize': 0.0001, 'symbolIndex': 377 },
            { 'symbol': 'BCHUSD', 'tickSize': 0.05, 'symbolIndex': 402 },
            { 'symbol': 'LTCUSD', 'tickSize': 0.01, 'symbolIndex': 407 },
            { 'symbol': 'LINKUSDT', 'tickSize': 0.001, 'symbolIndex': 441 },
            { 'symbol': 'DOGEUSDT', 'tickSize': 1e-05, 'symbolIndex': 476 },
            { 'symbol': 'DOTUSDT', 'tickSize': 0.001, 'symbolIndex': 519 },
            { 'symbol': 'ADAUSDT', 'tickSize': 0.0001, 'symbolIndex': 521 },
            { 'symbol': 'EOSUSDT', 'tickSize': 0.0001, 'symbolIndex': 539 },
            { 'symbol': 'BNBUSDT', 'tickSize': 0.01, 'symbolIndex': 542 },
            { 'symbol': 'SOLUSDT', 'tickSize': 0.01, 'symbolIndex': 549 },
            { 'symbol': 'XBTEUR', 'tickSize': 0.5, 'symbolIndex': 564 },
            { 'symbol': 'MATICUSDT', 'tickSize': 0.0001, 'symbolIndex': 588 },
            { 'symbol': 'LUNAUSD', 'tickSize': 0.001, 'symbolIndex': 649 },
            { 'symbol': 'AVAXUSD', 'tickSize': 0.001, 'symbolIndex': 675 },
            { 'symbol': 'ADAUSD', 'tickSize': 0.0001, 'symbolIndex': 676 },
            { 'symbol': 'DOGEUSD', 'tickSize': 1e-05, 'symbolIndex': 677 },
            { 'symbol': 'BNBUSD', 'tickSize': 0.01, 'symbolIndex': 678 },
            { 'symbol': 'DOTUSD', 'tickSize': 0.001, 'symbolIndex': 679 },
            { 'symbol': 'AXSUSD', 'tickSize': 0.01, 'symbolIndex': 706 },
            { 'symbol': 'EOSUSD', 'tickSize': 0.0001, 'symbolIndex': 707 },
            { 'symbol': 'LINKUSD', 'tickSize': 0.001, 'symbolIndex': 708 },
            { 'symbol': 'SOLUSD', 'tickSize': 0.01, 'symbolIndex': 709 },
            { 'symbol': 'XBTUSDT', 'tickSize': 0.5, 'symbolIndex': 732 },
            { 'symbol': 'ETHUSDT', 'tickSize': 0.05, 'symbolIndex': 734 },
            { 'symbol': 'XRPUSDT', 'tickSize': 0.0001, 'symbolIndex': 736 },
            { 'symbol': 'BCHUSDT', 'tickSize': 0.05, 'symbolIndex': 737 },
            { 'symbol': 'LTCUSDT', 'tickSize': 0.01, 'symbolIndex': 738 },
            { 'symbol': 'SHIBUSDT', 'tickSize': 1e-09, 'symbolIndex': 754 },
            { 'symbol': 'FTMUSDT', 'tickSize': 0.0001, 'symbolIndex': 755 },
            { 'symbol': 'SANDUSDT', 'tickSize': 0.0001, 'symbolIndex': 780 },
            { 'symbol': 'MANAUSDT', 'tickSize': 0.0001, 'symbolIndex': 781 },
            { 'symbol': 'ALTMEXTUSDT', 'tickSize': 0.01, 'symbolIndex': 801 },
            { 'symbol': 'DEFIMEXTUSDT', 'tickSize': 0.01, 'symbolIndex': 802 },
            { 'symbol': 'METAMEXTUSDT', 'tickSize': 0.01, 'symbolIndex': 803 },
            { 'symbol': 'AVAXUSDT', 'tickSize': 0.001, 'symbolIndex': 808 },
            { 'symbol': 'LUNAUSDT', 'tickSize': 0.001, 'symbolIndex': 809 },
            { 'symbol': 'APEUSDT', 'tickSize': 0.001, 'symbolIndex': 826 }
        ]);
        this._lookup.set('Binance', [
            { 'symbol': 'BTCUSDT', 'tickSize': 0.1 },
            { 'symbol': 'ETHUSDT', 'tickSize': 0.01 },
            { 'symbol': 'BCHUSDT', 'tickSize': 0.01 },
            { 'symbol': 'XRPUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'EOSUSDT', 'tickSize': 0.001 },
            { 'symbol': 'LTCUSDT', 'tickSize': 0.01 },
            { 'symbol': 'TRXUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'ETCUSDT', 'tickSize': 0.001 },
            { 'symbol': 'LINKUSDT', 'tickSize': 0.001 },
            { 'symbol': 'XLMUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'ADAUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'XMRUSDT', 'tickSize': 0.01 },
            { 'symbol': 'DASHUSDT', 'tickSize': 0.01 },
            { 'symbol': 'ZECUSDT', 'tickSize': 0.01 },
            { 'symbol': 'XTZUSDT', 'tickSize': 0.001 },
            { 'symbol': 'BNBUSDT', 'tickSize': 0.01 },
            { 'symbol': 'ATOMUSDT', 'tickSize': 0.001 },
            { 'symbol': 'ONTUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'IOTAUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'BATUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'VETUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'NEOUSDT', 'tickSize': 0.001 },
            { 'symbol': 'QTUMUSDT', 'tickSize': 0.001 },
            { 'symbol': 'IOSTUSDT', 'tickSize': 1e-06 },
            { 'symbol': 'THETAUSDT', 'tickSize': 0.001 },
            { 'symbol': 'ALGOUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'ZILUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'KNCUSDT', 'tickSize': 0.001 },
            { 'symbol': 'ZRXUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'COMPUSDT', 'tickSize': 0.01 },
            { 'symbol': 'OMGUSDT', 'tickSize': 0.001 },
            { 'symbol': 'DOGEUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'SXPUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'KAVAUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'BANDUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'RLCUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'WAVESUSDT', 'tickSize': 0.001 },
            { 'symbol': 'MKRUSDT', 'tickSize': 0.1 },
            { 'symbol': 'SNXUSDT', 'tickSize': 0.001 },
            { 'symbol': 'DOTUSDT', 'tickSize': 0.001 },
            { 'symbol': 'DEFIUSDT', 'tickSize': 0.1 },
            { 'symbol': 'YFIUSDT', 'tickSize': 1.0 },
            { 'symbol': 'BALUSDT', 'tickSize': 0.001 },
            { 'symbol': 'CRVUSDT', 'tickSize': 0.001 },
            { 'symbol': 'TRBUSDT', 'tickSize': 0.01 },
            { 'symbol': 'YFIIUSDT', 'tickSize': 0.1 },
            { 'symbol': 'RUNEUSDT', 'tickSize': 0.001 },
            { 'symbol': 'SUSHIUSDT', 'tickSize': 0.001 },
            { 'symbol': 'SRMUSDT', 'tickSize': 0.001 },
            { 'symbol': 'EGLDUSDT', 'tickSize': 0.01 },
            { 'symbol': 'SOLUSDT', 'tickSize': 0.01 },
            { 'symbol': 'ICXUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'STORJUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'BLZUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'UNIUSDT', 'tickSize': 0.001 },
            { 'symbol': 'AVAXUSDT', 'tickSize': 0.01 },
            { 'symbol': 'FTMUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'HNTUSDT', 'tickSize': 0.001 },
            { 'symbol': 'ENJUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'FLMUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'TOMOUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'RENUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'KSMUSDT', 'tickSize': 0.01 },
            { 'symbol': 'NEARUSDT', 'tickSize': 0.001 },
            { 'symbol': 'AAVEUSDT', 'tickSize': 0.01 },
            { 'symbol': 'FILUSDT', 'tickSize': 0.001 },
            { 'symbol': 'RSRUSDT', 'tickSize': 1e-06 },
            { 'symbol': 'LRCUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'MATICUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'OCEANUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'CVCUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'BELUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'CTKUSDT', 'tickSize': 0.001 },
            { 'symbol': 'AXSUSDT', 'tickSize': 0.01 },
            { 'symbol': 'ALPHAUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'ZENUSDT', 'tickSize': 0.001 },
            { 'symbol': 'SKLUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'GRTUSDT', 'tickSize': 1e-05 },
            { 'symbol': '1INCHUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'BTCBUSD', 'tickSize': 0.1 },
            { 'symbol': 'AKROUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'CHZUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'SANDUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'ANKRUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'LUNAUSDT', 'tickSize': 0.001 },
            { 'symbol': 'BTSUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'LITUSDT', 'tickSize': 0.001 },
            { 'symbol': 'UNFIUSDT', 'tickSize': 0.001 },
            { 'symbol': 'DODOUSDT', 'tickSize': 0.001 },
            { 'symbol': 'REEFUSDT', 'tickSize': 1e-06 },
            { 'symbol': 'RVNUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'SFPUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'XEMUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'BTCSTUSDT', 'tickSize': 0.001 },
            { 'symbol': 'COTIUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'CHRUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'MANAUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'ALICEUSDT', 'tickSize': 0.001 },
            { 'symbol': 'HBARUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'ONEUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'LINAUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'STMXUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'DENTUSDT', 'tickSize': 1e-06 },
            { 'symbol': 'CELRUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'HOTUSDT', 'tickSize': 1e-06 },
            { 'symbol': 'MTLUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'OGNUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'NKNUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'SCUSDT', 'tickSize': 1e-06 },
            { 'symbol': 'DGBUSDT', 'tickSize': 1e-05 },
            { 'symbol': '1000SHIBUSDT', 'tickSize': 1e-06 },
            { 'symbol': 'ICPUSDT', 'tickSize': 0.01 },
            { 'symbol': 'BAKEUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'GTCUSDT', 'tickSize': 0.001 },
            { 'symbol': 'ETHBUSD', 'tickSize': 0.01 },
            { 'symbol': 'BTCDOMUSDT', 'tickSize': 0.1 },
            { 'symbol': 'TLMUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'BNBBUSD', 'tickSize': 0.01 },
            { 'symbol': 'ADABUSD', 'tickSize': 0.0001 },
            { 'symbol': 'XRPBUSD', 'tickSize': 0.0001 },
            { 'symbol': 'IOTXUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'DOGEBUSD', 'tickSize': 1e-05 },
            { 'symbol': 'AUDIOUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'RAYUSDT', 'tickSize': 0.001 },
            { 'symbol': 'C98USDT', 'tickSize': 0.0001 },
            { 'symbol': 'MASKUSDT', 'tickSize': 0.001 },
            { 'symbol': 'ATAUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'SOLBUSD', 'tickSize': 0.01 },
            { 'symbol': 'FTTBUSD', 'tickSize': 0.001 },
            { 'symbol': 'DYDXUSDT', 'tickSize': 0.001 },
            { 'symbol': '1000XECUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'GALAUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'CELOUSDT', 'tickSize': 0.001 },
            { 'symbol': 'ARUSDT', 'tickSize': 0.001 },
            { 'symbol': 'KLAYUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'ARPAUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'CTSIUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'LPTUSDT', 'tickSize': 0.001 },
            { 'symbol': 'ENSUSDT', 'tickSize': 0.001 },
            { 'symbol': 'PEOPLEUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'ANTUSDT', 'tickSize': 0.001 },
            { 'symbol': 'ROSEUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'DUSKUSDT', 'tickSize': 1e-05 },
            { 'symbol': '1000BTTCUSDT', 'tickSize': 1e-06 },
            { 'symbol': 'FLOWUSDT', 'tickSize': 0.001 },
            { 'symbol': 'IMXUSDT', 'tickSize': 0.0001 },
            { 'symbol': 'API3USDT', 'tickSize': 0.001 },
            { 'symbol': 'ANCUSDT', 'tickSize': 0.001 },
            { 'symbol': 'GMTUSDT', 'tickSize': 1e-05 },
            { 'symbol': 'APEUSDT', 'tickSize': 0.001 },
            { 'symbol': 'BNXUSDT', 'tickSize': 0.01 }
        ]);
        this._lookup.set('Kraken', [
            { 'symbol': '1INCH/EUR', 'tickSize': 0.001 },
            { 'symbol': '1INCH/USD', 'tickSize': 0.001 },
            { 'symbol': 'AAVE/AUD', 'tickSize': 0.01 },
            { 'symbol': 'AAVE/ETH', 'tickSize': 0.0001 },
            { 'symbol': 'AAVE/EUR', 'tickSize': 0.01 },
            { 'symbol': 'AAVE/GBP', 'tickSize': 0.01 },
            { 'symbol': 'AAVE/USD', 'tickSize': 0.01 },
            { 'symbol': 'AAVE/XBT', 'tickSize': 1e-06 },
            { 'symbol': 'ACA/EUR', 'tickSize': 0.001 },
            { 'symbol': 'ACA/USD', 'tickSize': 0.001 },
            { 'symbol': 'ADA/AUD', 'tickSize': 1e-05 },
            { 'symbol': 'ADA/ETH', 'tickSize': 1e-07 },
            { 'symbol': 'ADA/EUR', 'tickSize': 1e-06 },
            { 'symbol': 'ADA/GBP', 'tickSize': 1e-05 },
            { 'symbol': 'ADA/USD', 'tickSize': 1e-06 },
            { 'symbol': 'ADA/USDT', 'tickSize': 1e-06 },
            { 'symbol': 'ADA/XBT', 'tickSize': 1e-08 },
            { 'symbol': 'AIR/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'AIR/USD', 'tickSize': 0.0001 },
            { 'symbol': 'AKT/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'AKT/USD', 'tickSize': 0.0001 },
            { 'symbol': 'ALCX/EUR', 'tickSize': 0.01 },
            { 'symbol': 'ALCX/USD', 'tickSize': 0.01 },
            { 'symbol': 'ALGO/ETH', 'tickSize': 1e-07 },
            { 'symbol': 'ALGO/EUR', 'tickSize': 1e-05 },
            { 'symbol': 'ALGO/GBP', 'tickSize': 1e-05 },
            { 'symbol': 'ALGO/USD', 'tickSize': 1e-05 },
            { 'symbol': 'ALGO/XBT', 'tickSize': 1e-08 },
            { 'symbol': 'ALICE/EUR', 'tickSize': 0.001 },
            { 'symbol': 'ALICE/USD', 'tickSize': 0.001 },
            { 'symbol': 'ANKR/EUR', 'tickSize': 1e-05 },
            { 'symbol': 'ANKR/GBP', 'tickSize': 1e-05 },
            { 'symbol': 'ANKR/USD', 'tickSize': 1e-05 },
            { 'symbol': 'ANKR/XBT', 'tickSize': 1e-08 },
            { 'symbol': 'ANT/ETH', 'tickSize': 1e-06 },
            { 'symbol': 'ANT/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'ANT/USD', 'tickSize': 0.0001 },
            { 'symbol': 'ANT/XBT', 'tickSize': 1e-08 },
            { 'symbol': 'APE/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'APE/USD', 'tickSize': 0.0001 },
            { 'symbol': 'ASTR/EUR', 'tickSize': 0.001 },
            { 'symbol': 'ASTR/USD', 'tickSize': 0.001 },
            { 'symbol': 'ATLAS/EUR', 'tickSize': 1e-05 },
            { 'symbol': 'ATLAS/USD', 'tickSize': 1e-05 },
            { 'symbol': 'ATOM/AUD', 'tickSize': 0.0001 },
            { 'symbol': 'ATOM/ETH', 'tickSize': 1e-06 },
            { 'symbol': 'ATOM/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'ATOM/GBP', 'tickSize': 0.0001 },
            { 'symbol': 'ATOM/USD', 'tickSize': 0.0001 },
            { 'symbol': 'ATOM/XBT', 'tickSize': 1e-07 },
            { 'symbol': 'AUDIO/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'AUDIO/USD', 'tickSize': 0.0001 },
            { 'symbol': 'AUD/JPY', 'tickSize': 0.001 },
            { 'symbol': 'AUD/USD', 'tickSize': 1e-05 },
            { 'symbol': 'AVAX/EUR', 'tickSize': 0.01 },
            { 'symbol': 'AVAX/USD', 'tickSize': 0.01 },
            { 'symbol': 'AXS/EUR', 'tickSize': 0.001 },
            { 'symbol': 'AXS/USD', 'tickSize': 0.001 },
            { 'symbol': 'BADGER/EUR', 'tickSize': 0.001 },
            { 'symbol': 'BADGER/USD', 'tickSize': 0.001 },
            { 'symbol': 'BAL/ETH', 'tickSize': 1e-05 },
            { 'symbol': 'BAL/EUR', 'tickSize': 0.01 },
            { 'symbol': 'BAL/USD', 'tickSize': 0.01 },
            { 'symbol': 'BAL/XBT', 'tickSize': 1e-06 },
            { 'symbol': 'BAND/EUR', 'tickSize': 0.001 },
            { 'symbol': 'BAND/USD', 'tickSize': 0.001 },
            { 'symbol': 'BAT/ETH', 'tickSize': 1e-07 },
            { 'symbol': 'BAT/EUR', 'tickSize': 1e-05 },
            { 'symbol': 'BAT/JPY', 'tickSize': 0.01 },
            { 'symbol': 'BAT/USD', 'tickSize': 1e-05 },
            { 'symbol': 'BAT/XBT', 'tickSize': 1e-08 },
            { 'symbol': 'BCH/AUD', 'tickSize': 0.01 },
            { 'symbol': 'BCH/ETH', 'tickSize': 0.0001 },
            { 'symbol': 'BCH/EUR', 'tickSize': 0.01 },
            { 'symbol': 'BCH/GBP', 'tickSize': 0.01 },
            { 'symbol': 'BCH/JPY', 'tickSize': 1 },
            { 'symbol': 'BCH/USD', 'tickSize': 0.01 },
            { 'symbol': 'BCH/USDT', 'tickSize': 0.01 },
            { 'symbol': 'BCH/XBT', 'tickSize': 1e-05 },
            { 'symbol': 'BICO/EUR', 'tickSize': 0.001 },
            { 'symbol': 'BICO/USD', 'tickSize': 0.001 },
            { 'symbol': 'BNC/EUR', 'tickSize': 0.01 },
            { 'symbol': 'BNC/USD', 'tickSize': 0.01 },
            { 'symbol': 'BNT/EUR', 'tickSize': 0.001 },
            { 'symbol': 'BNT/GBP', 'tickSize': 0.001 },
            { 'symbol': 'BNT/USD', 'tickSize': 0.001 },
            { 'symbol': 'BNT/XBT', 'tickSize': 1e-07 },
            { 'symbol': 'BOND/EUR', 'tickSize': 0.001 },
            { 'symbol': 'BOND/USD', 'tickSize': 0.001 },
            { 'symbol': 'CHZ/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'CHZ/USD', 'tickSize': 0.0001 },
            { 'symbol': 'COMP/ETH', 'tickSize': 0.0001 },
            { 'symbol': 'COMP/EUR', 'tickSize': 0.01 },
            { 'symbol': 'COMP/USD', 'tickSize': 0.01 },
            { 'symbol': 'COMP/XBT', 'tickSize': 1e-06 },
            { 'symbol': 'CQT/EUR', 'tickSize': 0.001 },
            { 'symbol': 'CQT/USD', 'tickSize': 0.001 },
            { 'symbol': 'CRV/ETH', 'tickSize': 1e-06 },
            { 'symbol': 'CRV/EUR', 'tickSize': 0.001 },
            { 'symbol': 'CRV/USD', 'tickSize': 0.001 },
            { 'symbol': 'CRV/XBT', 'tickSize': 1e-07 },
            { 'symbol': 'CTSI/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'CTSI/USD', 'tickSize': 0.0001 },
            { 'symbol': 'CVX/EUR', 'tickSize': 0.01 },
            { 'symbol': 'CVX/USD', 'tickSize': 0.01 },
            { 'symbol': 'DAI/EUR', 'tickSize': 1e-05 },
            { 'symbol': 'DAI/USD', 'tickSize': 1e-05 },
            { 'symbol': 'DAI/USDT', 'tickSize': 1e-05 },
            { 'symbol': 'DASH/EUR', 'tickSize': 0.001 },
            { 'symbol': 'DASH/USD', 'tickSize': 0.001 },
            { 'symbol': 'DASH/XBT', 'tickSize': 1e-05 },
            { 'symbol': 'DOT/AUD', 'tickSize': 0.0001 },
            { 'symbol': 'DOT/ETH', 'tickSize': 1e-06 },
            { 'symbol': 'DOT/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'DOT/GBP', 'tickSize': 0.0001 },
            { 'symbol': 'DOT/JPY', 'tickSize': 0.1 },
            { 'symbol': 'DOT/USD', 'tickSize': 0.0001 },
            { 'symbol': 'DOT/USDT', 'tickSize': 0.0001 },
            { 'symbol': 'DOT/XBT', 'tickSize': 1e-08 },
            { 'symbol': 'DYDX/EUR', 'tickSize': 0.001 },
            { 'symbol': 'DYDX/USD', 'tickSize': 0.001 },
            { 'symbol': 'ENJ/EUR', 'tickSize': 0.001 },
            { 'symbol': 'ENJ/GBP', 'tickSize': 0.001 },
            { 'symbol': 'ENJ/JPY', 'tickSize': 0.1 },
            { 'symbol': 'ENJ/USD', 'tickSize': 0.001 },
            { 'symbol': 'ENJ/XBT', 'tickSize': 1e-08 },
            { 'symbol': 'ENS/EUR', 'tickSize': 0.01 },
            { 'symbol': 'ENS/USD', 'tickSize': 0.01 },
            { 'symbol': 'EOS/ETH', 'tickSize': 1e-06 },
            { 'symbol': 'EOS/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'EOS/USD', 'tickSize': 0.0001 },
            { 'symbol': 'EOS/USDT', 'tickSize': 0.0001 },
            { 'symbol': 'EOS/XBT', 'tickSize': 1e-07 },
            { 'symbol': 'ETH2.S/ETH', 'tickSize': 0.0001 },
            { 'symbol': 'ETH/AUD', 'tickSize': 0.01 },
            { 'symbol': 'ETH/CHF', 'tickSize': 0.01 },
            { 'symbol': 'ETH/DAI', 'tickSize': 0.001 },
            { 'symbol': 'ETH/USDC', 'tickSize': 0.01 },
            { 'symbol': 'ETH/USDT', 'tickSize': 0.01 },
            { 'symbol': 'EUR/AUD', 'tickSize': 1e-05 },
            { 'symbol': 'EUR/CAD', 'tickSize': 1e-05 },
            { 'symbol': 'EUR/CHF', 'tickSize': 1e-05 },
            { 'symbol': 'EUR/GBP', 'tickSize': 1e-05 },
            { 'symbol': 'EUR/JPY', 'tickSize': 0.001 },
            { 'symbol': 'EWT/EUR', 'tickSize': 0.001 },
            { 'symbol': 'EWT/GBP', 'tickSize': 0.001 },
            { 'symbol': 'EWT/USD', 'tickSize': 0.001 },
            { 'symbol': 'EWT/XBT', 'tickSize': 1e-08 },
            { 'symbol': 'FIDA/EUR', 'tickSize': 0.001 },
            { 'symbol': 'FIDA/USD', 'tickSize': 0.001 },
            { 'symbol': 'FIL/AUD', 'tickSize': 0.001 },
            { 'symbol': 'FIL/ETH', 'tickSize': 1e-05 },
            { 'symbol': 'FIL/EUR', 'tickSize': 0.001 },
            { 'symbol': 'FIL/GBP', 'tickSize': 0.001 },
            { 'symbol': 'FIL/USD', 'tickSize': 0.001 },
            { 'symbol': 'FIL/XBT', 'tickSize': 1e-07 },
            { 'symbol': 'FLOW/ETH', 'tickSize': 1e-05 },
            { 'symbol': 'FLOW/EUR', 'tickSize': 0.001 },
            { 'symbol': 'FLOW/GBP', 'tickSize': 0.001 },
            { 'symbol': 'FLOW/USD', 'tickSize': 0.001 },
            { 'symbol': 'FLOW/XBT', 'tickSize': 1e-07 },
            { 'symbol': 'FXS/EUR', 'tickSize': 0.001 },
            { 'symbol': 'FXS/USD', 'tickSize': 0.001 },
            { 'symbol': 'GALA/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'GALA/USD', 'tickSize': 0.0001 },
            { 'symbol': 'GHST/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'GHST/GBP', 'tickSize': 0.0001 },
            { 'symbol': 'GHST/USD', 'tickSize': 0.0001 },
            { 'symbol': 'GHST/XBT', 'tickSize': 1e-08 },
            { 'symbol': 'GLMR/EUR', 'tickSize': 0.001 },
            { 'symbol': 'GLMR/USD', 'tickSize': 0.001 },
            { 'symbol': 'GNO/ETH', 'tickSize': 0.0001 },
            { 'symbol': 'GNO/EUR', 'tickSize': 0.01 },
            { 'symbol': 'GNO/USD', 'tickSize': 0.01 },
            { 'symbol': 'GNO/XBT', 'tickSize': 1e-05 },
            { 'symbol': 'GRT/AUD', 'tickSize': 1e-05 },
            { 'symbol': 'GRT/ETH', 'tickSize': 1e-07 },
            { 'symbol': 'GRT/EUR', 'tickSize': 1e-05 },
            { 'symbol': 'GRT/GBP', 'tickSize': 1e-05 },
            { 'symbol': 'GRT/USD', 'tickSize': 1e-05 },
            { 'symbol': 'GRT/XBT', 'tickSize': 1e-08 },
            { 'symbol': 'ICP/EUR', 'tickSize': 0.001 },
            { 'symbol': 'ICP/USD', 'tickSize': 0.001 },
            { 'symbol': 'ICX/ETH', 'tickSize': 1e-07 },
            { 'symbol': 'ICX/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'ICX/USD', 'tickSize': 0.0001 },
            { 'symbol': 'ICX/XBT', 'tickSize': 1e-08 },
            { 'symbol': 'IMX/EUR', 'tickSize': 0.001 },
            { 'symbol': 'IMX/USD', 'tickSize': 0.001 },
            { 'symbol': 'INJ/EUR', 'tickSize': 0.001 },
            { 'symbol': 'INJ/USD', 'tickSize': 0.001 },
            { 'symbol': 'JASMY/EUR', 'tickSize': 1e-05 },
            { 'symbol': 'JASMY/USD', 'tickSize': 1e-05 },
            { 'symbol': 'KAR/EUR', 'tickSize': 0.001 },
            { 'symbol': 'KAR/USD', 'tickSize': 0.001 },
            { 'symbol': 'KAVA/ETH', 'tickSize': 1e-06 },
            { 'symbol': 'KAVA/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'KAVA/USD', 'tickSize': 0.0001 },
            { 'symbol': 'KAVA/XBT', 'tickSize': 1e-08 },
            { 'symbol': 'KEEP/ETH', 'tickSize': 1e-07 },
            { 'symbol': 'KEEP/EUR', 'tickSize': 1e-05 },
            { 'symbol': 'KEEP/USD', 'tickSize': 1e-05 },
            { 'symbol': 'KEEP/XBT', 'tickSize': 1e-08 },
            { 'symbol': 'KILT/EUR', 'tickSize': 0.01 },
            { 'symbol': 'KILT/USD', 'tickSize': 0.01 },
            { 'symbol': 'KIN/EUR', 'tickSize': 1e-08 },
            { 'symbol': 'KINT/EUR', 'tickSize': 0.01 },
            { 'symbol': 'KINT/USD', 'tickSize': 0.01 },
            { 'symbol': 'KIN/USD', 'tickSize': 1e-08 },
            { 'symbol': 'KNC/ETH', 'tickSize': 1e-06 },
            { 'symbol': 'KNC/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'KNC/USD', 'tickSize': 0.0001 },
            { 'symbol': 'KNC/XBT', 'tickSize': 1e-08 },
            { 'symbol': 'KP3R/EUR', 'tickSize': 0.1 },
            { 'symbol': 'KP3R/USD', 'tickSize': 0.1 },
            { 'symbol': 'KSM/AUD', 'tickSize': 0.01 },
            { 'symbol': 'KSM/DOT', 'tickSize': 0.01 },
            { 'symbol': 'KSM/ETH', 'tickSize': 1e-05 },
            { 'symbol': 'KSM/EUR', 'tickSize': 0.01 },
            { 'symbol': 'KSM/GBP', 'tickSize': 0.01 },
            { 'symbol': 'KSM/USD', 'tickSize': 0.01 },
            { 'symbol': 'KSM/XBT', 'tickSize': 1e-06 },
            { 'symbol': 'LINK/AUD', 'tickSize': 0.001 },
            { 'symbol': 'LINK/ETH', 'tickSize': 1e-08 },
            { 'symbol': 'LINK/EUR', 'tickSize': 1e-05 },
            { 'symbol': 'LINK/GBP', 'tickSize': 0.001 },
            { 'symbol': 'LINK/JPY', 'tickSize': 0.1 },
            { 'symbol': 'LINK/USD', 'tickSize': 1e-05 },
            { 'symbol': 'LINK/USDT', 'tickSize': 1e-05 },
            { 'symbol': 'LINK/XBT', 'tickSize': 1e-08 },
            { 'symbol': 'LPT/EUR', 'tickSize': 0.01 },
            { 'symbol': 'LPT/GBP', 'tickSize': 0.01 },
            { 'symbol': 'LPT/USD', 'tickSize': 0.01 },
            { 'symbol': 'LPT/XBT', 'tickSize': 1e-07 },
            { 'symbol': 'LRC/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'LRC/USD', 'tickSize': 0.0001 },
            { 'symbol': 'LSK/ETH', 'tickSize': 1e-08 },
            { 'symbol': 'LSK/EUR', 'tickSize': 1e-06 },
            { 'symbol': 'LSK/USD', 'tickSize': 1e-06 },
            { 'symbol': 'LSK/XBT', 'tickSize': 1e-09 },
            { 'symbol': 'LTC/AUD', 'tickSize': 0.01 },
            { 'symbol': 'LTC/ETH', 'tickSize': 1e-05 },
            { 'symbol': 'LTC/GBP', 'tickSize': 1e-05 },
            { 'symbol': 'LTC/USDT', 'tickSize': 1e-05 },
            { 'symbol': 'LUNA/EUR', 'tickSize': 0.01 },
            { 'symbol': 'LUNA/USD', 'tickSize': 0.01 },
            { 'symbol': 'MANA/ETH', 'tickSize': 1e-07 },
            { 'symbol': 'MANA/EUR', 'tickSize': 1e-05 },
            { 'symbol': 'MANA/USD', 'tickSize': 1e-05 },
            { 'symbol': 'MANA/XBT', 'tickSize': 1e-08 },
            { 'symbol': 'MASK/EUR', 'tickSize': 0.001 },
            { 'symbol': 'MASK/USD', 'tickSize': 0.001 },
            { 'symbol': 'MATIC/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'MATIC/GBP', 'tickSize': 0.0001 },
            { 'symbol': 'MATIC/USD', 'tickSize': 0.0001 },
            { 'symbol': 'MATIC/XBT', 'tickSize': 1e-08 },
            { 'symbol': 'MC/EUR', 'tickSize': 0.001 },
            { 'symbol': 'MC/USD', 'tickSize': 0.001 },
            { 'symbol': 'MINA/EUR', 'tickSize': 0.01 },
            { 'symbol': 'MINA/GBP', 'tickSize': 0.01 },
            { 'symbol': 'MINA/USD', 'tickSize': 0.01 },
            { 'symbol': 'MINA/XBT', 'tickSize': 1e-07 },
            { 'symbol': 'MIR/EUR', 'tickSize': 0.001 },
            { 'symbol': 'MIR/USD', 'tickSize': 0.001 },
            { 'symbol': 'MKR/EUR', 'tickSize': 0.1 },
            { 'symbol': 'MKR/GBP', 'tickSize': 0.1 },
            { 'symbol': 'MKR/USD', 'tickSize': 0.1 },
            { 'symbol': 'MKR/XBT', 'tickSize': 1e-05 },
            { 'symbol': 'MNGO/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'MNGO/USD', 'tickSize': 0.0001 },
            { 'symbol': 'MOVR/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'MOVR/USD', 'tickSize': 0.0001 },
            { 'symbol': 'MULTI/EUR', 'tickSize': 0.001 },
            { 'symbol': 'MULTI/USD', 'tickSize': 0.001 },
            { 'symbol': 'NANO/ETH', 'tickSize': 1e-08 },
            { 'symbol': 'NANO/EUR', 'tickSize': 1e-06 },
            { 'symbol': 'NANO/USD', 'tickSize': 1e-06 },
            { 'symbol': 'NANO/XBT', 'tickSize': 1e-09 },
            { 'symbol': 'OCEAN/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'OCEAN/GBP', 'tickSize': 0.0001 },
            { 'symbol': 'OCEAN/USD', 'tickSize': 0.0001 },
            { 'symbol': 'OCEAN/XBT', 'tickSize': 1e-08 },
            { 'symbol': 'OGN/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'OGN/USD', 'tickSize': 0.0001 },
            { 'symbol': 'OMG/ETH', 'tickSize': 1e-08 },
            { 'symbol': 'OMG/EUR', 'tickSize': 1e-06 },
            { 'symbol': 'OMG/JPY', 'tickSize': 0.1 },
            { 'symbol': 'OMG/USD', 'tickSize': 1e-06 },
            { 'symbol': 'OMG/XBT', 'tickSize': 1e-09 },
            { 'symbol': 'ORCA/EUR', 'tickSize': 0.001 },
            { 'symbol': 'ORCA/USD', 'tickSize': 0.001 },
            { 'symbol': 'OXT/ETH', 'tickSize': 1e-07 },
            { 'symbol': 'OXT/EUR', 'tickSize': 1e-05 },
            { 'symbol': 'OXT/USD', 'tickSize': 1e-05 },
            { 'symbol': 'OXT/XBT', 'tickSize': 1e-08 },
            { 'symbol': 'OXY/EUR', 'tickSize': 0.001 },
            { 'symbol': 'OXY/USD', 'tickSize': 0.001 },
            { 'symbol': 'PAXG/ETH', 'tickSize': 1e-06 },
            { 'symbol': 'PAXG/EUR', 'tickSize': 0.01 },
            { 'symbol': 'PAXG/USD', 'tickSize': 0.01 },
            { 'symbol': 'PAXG/XBT', 'tickSize': 1e-06 },
            { 'symbol': 'PERP/EUR', 'tickSize': 0.001 },
            { 'symbol': 'PERP/USD', 'tickSize': 0.001 },
            { 'symbol': 'PHA/EUR', 'tickSize': 0.001 },
            { 'symbol': 'PHA/USD', 'tickSize': 0.001 },
            { 'symbol': 'PLA/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'PLA/USD', 'tickSize': 0.0001 },
            { 'symbol': 'POLIS/EUR', 'tickSize': 0.001 },
            { 'symbol': 'POLIS/USD', 'tickSize': 0.001 },
            { 'symbol': 'POWR/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'POWR/USD', 'tickSize': 0.0001 },
            { 'symbol': 'PSTAKE/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'PSTAKE/USD', 'tickSize': 0.0001 },
            { 'symbol': 'QNT/EUR', 'tickSize': 0.01 },
            { 'symbol': 'QNT/USD', 'tickSize': 0.01 },
            { 'symbol': 'QTUM/ETH', 'tickSize': 1e-07 },
            { 'symbol': 'QTUM/EUR', 'tickSize': 1e-05 },
            { 'symbol': 'QTUM/USD', 'tickSize': 1e-05 },
            { 'symbol': 'QTUM/XBT', 'tickSize': 1e-07 },
            { 'symbol': 'RARE/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'RARE/USD', 'tickSize': 0.0001 },
            { 'symbol': 'RARI/EUR', 'tickSize': 0.01 },
            { 'symbol': 'RARI/GBP', 'tickSize': 0.01 },
            { 'symbol': 'RARI/USD', 'tickSize': 0.01 },
            { 'symbol': 'RARI/XBT', 'tickSize': 1e-07 },
            { 'symbol': 'RAY/EUR', 'tickSize': 0.001 },
            { 'symbol': 'RAY/USD', 'tickSize': 0.001 },
            { 'symbol': 'RBC/EUR', 'tickSize': 1e-05 },
            { 'symbol': 'RBC/USD', 'tickSize': 1e-05 },
            { 'symbol': 'REN/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'REN/GBP', 'tickSize': 0.0001 },
            { 'symbol': 'REN/USD', 'tickSize': 0.0001 },
            { 'symbol': 'REN/XBT', 'tickSize': 1e-08 },
            { 'symbol': 'REPV2/ETH', 'tickSize': 1e-05 },
            { 'symbol': 'REPV2/EUR', 'tickSize': 0.001 },
            { 'symbol': 'REPV2/USD', 'tickSize': 0.001 },
            { 'symbol': 'REPV2/XBT', 'tickSize': 1e-06 },
            { 'symbol': 'RNDR/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'RNDR/USD', 'tickSize': 0.0001 },
            { 'symbol': 'SAND/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'SAND/GBP', 'tickSize': 0.0001 },
            { 'symbol': 'SAND/USD', 'tickSize': 0.0001 },
            { 'symbol': 'SAND/XBT', 'tickSize': 1e-08 },
            { 'symbol': 'SBR/EUR', 'tickSize': 1e-05 },
            { 'symbol': 'SBR/USD', 'tickSize': 1e-05 },
            { 'symbol': 'SC/ETH', 'tickSize': 1e-08 },
            { 'symbol': 'SC/EUR', 'tickSize': 1e-05 },
            { 'symbol': 'SCRT/EUR', 'tickSize': 0.001 },
            { 'symbol': 'SCRT/USD', 'tickSize': 0.001 },
            { 'symbol': 'SC/USD', 'tickSize': 1e-05 },
            { 'symbol': 'SC/XBT', 'tickSize': 1e-10 },
            { 'symbol': 'SDN/EUR', 'tickSize': 0.001 },
            { 'symbol': 'SDN/USD', 'tickSize': 0.001 },
            { 'symbol': 'SGB/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'SGB/USD', 'tickSize': 0.0001 },
            { 'symbol': 'SHIB/EUR', 'tickSize': 1e-08 },
            { 'symbol': 'SHIB/USD', 'tickSize': 1e-08 },
            { 'symbol': 'SNX/AUD', 'tickSize': 0.001 },
            { 'symbol': 'SNX/ETH', 'tickSize': 1e-05 },
            { 'symbol': 'SNX/EUR', 'tickSize': 0.001 },
            { 'symbol': 'SNX/GBP', 'tickSize': 0.001 },
            { 'symbol': 'SNX/USD', 'tickSize': 0.001 },
            { 'symbol': 'SNX/XBT', 'tickSize': 1e-07 },
            { 'symbol': 'SOL/EUR', 'tickSize': 0.01 },
            { 'symbol': 'SOL/GBP', 'tickSize': 0.01 },
            { 'symbol': 'SOL/USD', 'tickSize': 0.01 },
            { 'symbol': 'SOL/XBT', 'tickSize': 1e-07 },
            { 'symbol': 'SPELL/EUR', 'tickSize': 1e-06 },
            { 'symbol': 'SPELL/USD', 'tickSize': 1e-06 },
            { 'symbol': 'SRM/EUR', 'tickSize': 0.001 },
            { 'symbol': 'SRM/GBP', 'tickSize': 0.001 },
            { 'symbol': 'SRM/USD', 'tickSize': 0.001 },
            { 'symbol': 'SRM/XBT', 'tickSize': 1e-08 },
            { 'symbol': 'STEP/EUR', 'tickSize': 0.001 },
            { 'symbol': 'STEP/USD', 'tickSize': 0.001 },
            { 'symbol': 'STORJ/ETH', 'tickSize': 1e-07 },
            { 'symbol': 'STORJ/EUR', 'tickSize': 1e-05 },
            { 'symbol': 'STORJ/USD', 'tickSize': 1e-05 },
            { 'symbol': 'STORJ/XBT', 'tickSize': 1e-09 },
            { 'symbol': 'SUSHI/EUR', 'tickSize': 0.01 },
            { 'symbol': 'SUSHI/GBP', 'tickSize': 0.01 },
            { 'symbol': 'SUSHI/USD', 'tickSize': 0.01 },
            { 'symbol': 'SUSHI/XBT', 'tickSize': 1e-07 },
            { 'symbol': 'TBTC/ETH', 'tickSize': 0.001 },
            { 'symbol': 'TBTC/EUR', 'tickSize': 0.1 },
            { 'symbol': 'TBTC/USD', 'tickSize': 0.1 },
            { 'symbol': 'TBTC/XBT', 'tickSize': 1e-05 },
            { 'symbol': 'TOKE/EUR', 'tickSize': 0.01 },
            { 'symbol': 'TOKE/USD', 'tickSize': 0.01 },
            { 'symbol': 'TRIBE/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'TRIBE/USD', 'tickSize': 0.0001 },
            { 'symbol': 'TRX/ETH', 'tickSize': 1e-08 },
            { 'symbol': 'TRX/EUR', 'tickSize': 1e-06 },
            { 'symbol': 'TRX/USD', 'tickSize': 1e-06 },
            { 'symbol': 'TRX/XBT', 'tickSize': 1e-10 },
            { 'symbol': 'UMA/EUR', 'tickSize': 0.001 },
            { 'symbol': 'UMA/USD', 'tickSize': 0.001 },
            { 'symbol': 'UNI/ETH', 'tickSize': 1e-05 },
            { 'symbol': 'UNI/EUR', 'tickSize': 0.001 },
            { 'symbol': 'UNI/USD', 'tickSize': 0.001 },
            { 'symbol': 'UNI/XBT', 'tickSize': 1e-07 },
            { 'symbol': 'USDC/AUD', 'tickSize': 0.0001 },
            { 'symbol': 'USDC/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'USDC/GBP', 'tickSize': 0.0001 },
            { 'symbol': 'USD/CHF', 'tickSize': 1e-05 },
            { 'symbol': 'USDC/USD', 'tickSize': 0.0001 },
            { 'symbol': 'USDC/USDT', 'tickSize': 0.0001 },
            { 'symbol': 'USDT/AUD', 'tickSize': 0.0001 },
            { 'symbol': 'USDT/CAD', 'tickSize': 0.0001 },
            { 'symbol': 'USDT/CHF', 'tickSize': 1e-05 },
            { 'symbol': 'USDT/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'USDT/GBP', 'tickSize': 0.0001 },
            { 'symbol': 'USDT/JPY', 'tickSize': 0.001 },
            { 'symbol': 'USDT/USD', 'tickSize': 0.0001 },
            { 'symbol': 'UST/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'UST/USD', 'tickSize': 0.0001 },
            { 'symbol': 'UST/USDC', 'tickSize': 0.0001 },
            { 'symbol': 'UST/USDT', 'tickSize': 0.0001 },
            { 'symbol': 'WAVES/ETH', 'tickSize': 1e-07 },
            { 'symbol': 'WAVES/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'WAVES/USD', 'tickSize': 0.0001 },
            { 'symbol': 'WAVES/XBT', 'tickSize': 1e-08 },
            { 'symbol': 'WBTC/EUR', 'tickSize': 0.1 },
            { 'symbol': 'WBTC/USD', 'tickSize': 0.1 },
            { 'symbol': 'WBTC/XBT', 'tickSize': 1e-05 },
            { 'symbol': 'WOO/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'WOO/USD', 'tickSize': 0.0001 },
            { 'symbol': 'XBT/AUD', 'tickSize': 0.1 },
            { 'symbol': 'XBT/CHF', 'tickSize': 0.1 },
            { 'symbol': 'XBT/DAI', 'tickSize': 0.1 },
            { 'symbol': 'XBT/USDC', 'tickSize': 0.01 },
            { 'symbol': 'XBT/USDT', 'tickSize': 0.1 },
            { 'symbol': 'XDG/EUR', 'tickSize': 1e-07 },
            { 'symbol': 'XDG/USD', 'tickSize': 1e-07 },
            { 'symbol': 'XDG/USDT', 'tickSize': 1e-05 },
            { 'symbol': 'ETC/ETH', 'tickSize': 1e-06 },
            { 'symbol': 'ETC/XBT', 'tickSize': 1e-06 },
            { 'symbol': 'ETC/EUR', 'tickSize': 0.001 },
            { 'symbol': 'ETC/USD', 'tickSize': 0.001 },
            { 'symbol': 'ETH/XBT', 'tickSize': 1e-05 },
            { 'symbol': 'ETH/CAD', 'tickSize': 0.01 },
            { 'symbol': 'ETH/EUR', 'tickSize': 0.01 },
            { 'symbol': 'ETH/GBP', 'tickSize': 0.01 },
            { 'symbol': 'ETH/JPY', 'tickSize': 1 },
            { 'symbol': 'ETH/USD', 'tickSize': 0.01 },
            { 'symbol': 'LTC/XBT', 'tickSize': 1e-06 },
            { 'symbol': 'LTC/EUR', 'tickSize': 0.01 },
            { 'symbol': 'LTC/JPY', 'tickSize': 1 },
            { 'symbol': 'LTC/USD', 'tickSize': 0.01 },
            { 'symbol': 'MLN/ETH', 'tickSize': 1e-05 },
            { 'symbol': 'MLN/XBT', 'tickSize': 1e-06 },
            { 'symbol': 'MLN/EUR', 'tickSize': 0.001 },
            { 'symbol': 'MLN/USD', 'tickSize': 0.001 },
            { 'symbol': 'REP/ETH', 'tickSize': 1e-05 },
            { 'symbol': 'REP/XBT', 'tickSize': 1e-06 },
            { 'symbol': 'REP/EUR', 'tickSize': 0.001 },
            { 'symbol': 'REP/USD', 'tickSize': 0.001 },
            { 'symbol': 'XRP/AUD', 'tickSize': 1e-05 },
            { 'symbol': 'XRP/ETH', 'tickSize': 1e-07 },
            { 'symbol': 'XRP/GBP', 'tickSize': 1e-05 },
            { 'symbol': 'XRP/USDT', 'tickSize': 1e-05 },
            { 'symbol': 'XRT/EUR', 'tickSize': 0.01 },
            { 'symbol': 'XRT/USD', 'tickSize': 0.01 },
            { 'symbol': 'XTZ/AUD', 'tickSize': 0.0001 },
            { 'symbol': 'XTZ/ETH', 'tickSize': 1e-07 },
            { 'symbol': 'XTZ/EUR', 'tickSize': 0.0001 },
            { 'symbol': 'XTZ/GBP', 'tickSize': 0.0001 },
            { 'symbol': 'XTZ/USD', 'tickSize': 0.0001 },
            { 'symbol': 'XTZ/XBT', 'tickSize': 1e-07 },
            { 'symbol': 'XBT/CAD', 'tickSize': 0.1 },
            { 'symbol': 'XBT/EUR', 'tickSize': 0.1 },
            { 'symbol': 'XBT/GBP', 'tickSize': 0.1 },
            { 'symbol': 'XBT/JPY', 'tickSize': 1 },
            { 'symbol': 'XBT/USD', 'tickSize': 0.1 },
            { 'symbol': 'XDG/XBT', 'tickSize': 1e-08 },
            { 'symbol': 'XLM/XBT', 'tickSize': 1e-08 },
            { 'symbol': 'XLM/AUD', 'tickSize': 1e-05 },
            { 'symbol': 'XLM/EUR', 'tickSize': 1e-06 },
            { 'symbol': 'XLM/GBP', 'tickSize': 1e-05 },
            { 'symbol': 'XLM/USD', 'tickSize': 1e-06 },
            { 'symbol': 'XMR/XBT', 'tickSize': 1e-06 },
            { 'symbol': 'XMR/EUR', 'tickSize': 0.01 },
            { 'symbol': 'XMR/USD', 'tickSize': 0.01 },
            { 'symbol': 'XRP/XBT', 'tickSize': 1e-08 },
            { 'symbol': 'XRP/CAD', 'tickSize': 1e-05 },
            { 'symbol': 'XRP/EUR', 'tickSize': 1e-05 },
            { 'symbol': 'XRP/JPY', 'tickSize': 0.001 },
            { 'symbol': 'XRP/USD', 'tickSize': 1e-05 },
            { 'symbol': 'ZEC/XBT', 'tickSize': 1e-05 },
            { 'symbol': 'ZEC/EUR', 'tickSize': 0.001 },
            { 'symbol': 'ZEC/USD', 'tickSize': 0.01 },
            { 'symbol': 'YFI/AUD', 'tickSize': 1 },
            { 'symbol': 'YFI/ETH', 'tickSize': 0.01 },
            { 'symbol': 'YFI/EUR', 'tickSize': 1 },
            { 'symbol': 'YFI/GBP', 'tickSize': 1 },
            { 'symbol': 'YFI/USD', 'tickSize': 1 },
            { 'symbol': 'YFI/XBT', 'tickSize': 0.0001 },
            { 'symbol': 'YGG/EUR', 'tickSize': 0.001 },
            { 'symbol': 'YGG/USD', 'tickSize': 0.001 },
            { 'symbol': 'EUR/USD', 'tickSize': 1e-05 },
            { 'symbol': 'GBP/USD', 'tickSize': 1e-05 },
            { 'symbol': 'ZRX/EUR', 'tickSize': 0.001 },
            { 'symbol': 'ZRX/GBP', 'tickSize': 0.001 },
            { 'symbol': 'ZRX/USD', 'tickSize': 0.001 },
            { 'symbol': 'ZRX/XBT', 'tickSize': 1e-08 },
            { 'symbol': 'USD/CAD', 'tickSize': 1e-05 },
            { 'symbol': 'USD/JPY', 'tickSize': 0.001 }
        ]);
    }
    getExchanges() {
        return [...this._lookup.keys()];
    }
    getExchangeInstruments(exchange) {
        return this._lookup.get(exchange);
    }
    getExchangeInstrument(exchange, symbol) {
        const symbols = this.getExchangeInstruments(exchange);
        return symbols.find((ins) => ins.symbol === symbol);
    }
}
exports.InstrumentRepository = InstrumentRepository;
